export const templateData = [
  {
    "Product Title": "Wireless Gaming Mouse",
    Category: "Electronics",
    Brand: "Logitech",
    Unit: "units",
    "SKU Code": "SKU-0002",
    MRP: 8500,
    "Alert Quantity": 10,
    Description: "High precision gaming mouse",
    Barcode: "10002002",
    "Initial Stock Qty": 15,
    "Cost Price": 4500,
    "Retail Price": 7500,
    "Wholesale Price": 6500,
  },
  {
    "Product Title": "Running Shoes Pro",
    Category: "Footwear",
    Brand: "Nike",
    Unit: "pairs",
    "SKU Code": "SKU-0003",
    MRP: 6500,
    "Alert Quantity": 8,
    Description: "Lightweight running shoes",
    Barcode: "10002003",
    "Initial Stock Qty": 25,
    "Cost Price": 3200,
    "Retail Price": 5800,
    "Wholesale Price": 5200,
  },
  {
    "Product Title": "Leather Wallet",
    Category: "Accessories",
    Brand: "Fossil",
    Unit: "pcs",
    "SKU Code": "SKU-0004",
    MRP: 3000,
    "Alert Quantity": 6,
    Description: "Genuine leather wallet",
    Barcode: "10002004",
    "Initial Stock Qty": 40,
    "Cost Price": 1500,
    "Retail Price": 2700,
    "Wholesale Price": 2400,
  },
  {
    "Product Title": "Bluetooth Speaker",
    Category: "Electronics",
    Brand: "JBL",
    Unit: "units",
    "SKU Code": "SKU-0005",
    MRP: 5500,
    "Alert Quantity": 7,
    Description: "Portable bluetooth speaker",
    Barcode: "10002005",
    "Initial Stock Qty": 18,
    "Cost Price": 2800,
    "Retail Price": 5000,
    "Wholesale Price": 4500,
  },
  {
    "Product Title": "Cotton Polo Shirt 25",
    Category: "Apparel",
    Brand: "ClassicWear",
    Unit: "pcs",
    "SKU Code": "SKU-0025",
    MRP: 1500,
    "Alert Quantity": 5,
    Description: "Comfort fit polo shirt",
    Barcode: "10002025",
    "Initial Stock Qty": 35,
    "Cost Price": 700,
    "Retail Price": 1300,
    "Wholesale Price": 1100,
  },
  {
    "Product Title": "Smart Watch Series 26",
    Category: "Electronics",
    Brand: "Samsung",
    Unit: "units",
    "SKU Code": "SKU-0026",
    MRP: 15000,
    "Alert Quantity": 5,
    Description: "Fitness tracking smart watch",
    Barcode: "10002026",
    "Initial Stock Qty": 12,
    "Cost Price": 9000,
    "Retail Price": 13500,
    "Wholesale Price": 12000,
  },
  {
    "Product Title": "Casual Sneakers 27",
    Category: "Footwear",
    Brand: "Adidas",
    Unit: "pairs",
    "SKU Code": "SKU-0027",
    MRP: 5200,
    "Alert Quantity": 6,
    Description: "Daily wear sneakers",
    Barcode: "10002027",
    "Initial Stock Qty": 22,
    "Cost Price": 2500,
    "Retail Price": 4800,
    "Wholesale Price": 4300,
  },
  {
    "Product Title": "Travel Backpack 28",
    Category: "Accessories",
    Brand: "Wildcraft",
    Unit: "pcs",
    "SKU Code": "SKU-0028",
    MRP: 4000,
    "Alert Quantity": 6,
    Description: "Durable travel backpack",
    Barcode: "10002028",
    "Initial Stock Qty": 30,
    "Cost Price": 1800,
    "Retail Price": 3500,
    "Wholesale Price": 3000,
  },
  {
    "Product Title": "Coffee Maker 29",
    Category: "Home & Kitchen",
    Brand: "Philips",
    Unit: "units",
    "SKU Code": "SKU-0029",
    MRP: 9000,
    "Alert Quantity": 4,
    Description: "Automatic coffee machine",
    Barcode: "10002029",
    "Initial Stock Qty": 10,
    "Cost Price": 5000,
    "Retail Price": 8500,
    "Wholesale Price": 7800,
  },

  {
    "Product Title": "Denim Jeans 30",
    Category: "Apparel",
    Brand: "Levi's",
    Unit: "pcs",
    "SKU Code": "SKU-0030",
    MRP: 3500,
    "Alert Quantity": 6,
    Description: "Slim fit denim jeans",
    Barcode: "10002030",
    "Initial Stock Qty": 28,
    "Cost Price": 1800,
    "Retail Price": 3200,
    "Wholesale Price": 2900,
  },
  {
    "Product Title": "Noise Cancelling Headphones 31",
    Category: "Electronics",
    Brand: "Sony",
    Unit: "units",
    "SKU Code": "SKU-0031",
    MRP: 12000,
    "Alert Quantity": 5,
    Description: "Over-ear wireless headphones",
    Barcode: "10002031",
    "Initial Stock Qty": 20,
    "Cost Price": 7000,
    "Retail Price": 11000,
    "Wholesale Price": 9800,
  },
  {
    "Product Title": "Hoodie Jacket 32",
    Category: "Apparel",
    Brand: "Puma",
    Unit: "pcs",
    "SKU Code": "SKU-0032",
    MRP: 2800,
    "Alert Quantity": 7,
    Description: "Warm cotton hoodie",
    Barcode: "10002032",
    "Initial Stock Qty": 32,
    "Cost Price": 1400,
    "Retail Price": 2500,
    "Wholesale Price": 2200,
  },
  {
    "Product Title": "Tablet 10-inch 33",
    Category: "Electronics",
    Brand: "Apple",
    Unit: "units",
    "SKU Code": "SKU-0033",
    MRP: 45000,
    "Alert Quantity": 3,
    Description: "High performance tablet",
    Barcode: "10002033",
    "Initial Stock Qty": 8,
    "Cost Price": 30000,
    "Retail Price": 42000,
    "Wholesale Price": 39000,
  },
  {
    "Product Title": "Office Chair 34",
    Category: "Home & Kitchen",
    Brand: "Ikea",
    Unit: "units",
    "SKU Code": "SKU-0034",
    MRP: 8000,
    "Alert Quantity": 4,
    Description: "Ergonomic office chair",
    Barcode: "10002034",
    "Initial Stock Qty": 14,
    "Cost Price": 5000,
    "Retail Price": 7500,
    "Wholesale Price": 6800,
  },

  {
    "Product Title": "Water Bottle Steel 35",
    Category: "Accessories",
    Brand: "Milton",
    Unit: "pcs",
    "SKU Code": "SKU-0035",
    MRP: 900,
    "Alert Quantity": 10,
    Description: "Insulated steel bottle",
    Barcode: "10002035",
    "Initial Stock Qty": 60,
    "Cost Price": 450,
    "Retail Price": 800,
    "Wholesale Price": 700,
  },
  {
    "Product Title": "Sunglasses UV Protection 36",
    Category: "Accessories",
    Brand: "RayBan",
    Unit: "pcs",
    "SKU Code": "SKU-0036",
    MRP: 5000,
    "Alert Quantity": 5,
    Description: "Stylish UV protection sunglasses",
    Barcode: "10002036",
    "Initial Stock Qty": 18,
    "Cost Price": 2500,
    "Retail Price": 4500,
    "Wholesale Price": 4000,
  },
  {
    "Product Title": "Mechanical Keyboard 37",
    Category: "Electronics",
    Brand: "Corsair",
    Unit: "units",
    "SKU Code": "SKU-0037",
    MRP: 7000,
    "Alert Quantity": 6,
    Description: "RGB gaming keyboard",
    Barcode: "10002037",
    "Initial Stock Qty": 22,
    "Cost Price": 4000,
    "Retail Price": 6500,
    "Wholesale Price": 5800,
  },
  {
    "Product Title": "LED Monitor 24-inch 38",
    Category: "Electronics",
    Brand: "Dell",
    Unit: "units",
    "SKU Code": "SKU-0038",
    MRP: 15000,
    "Alert Quantity": 4,
    Description: "Full HD LED monitor",
    Barcode: "10002038",
    "Initial Stock Qty": 10,
    "Cost Price": 10000,
    "Retail Price": 14000,
    "Wholesale Price": 12500,
  },
  {
    "Product Title": "Microwave Oven 39",
    Category: "Home & Kitchen",
    Brand: "LG",
    Unit: "units",
    "SKU Code": "SKU-0039",
    MRP: 12000,
    "Alert Quantity": 3,
    Description: "Smart microwave oven",
    Barcode: "10002039",
    "Initial Stock Qty": 9,
    "Cost Price": 8000,
    "Retail Price": 11000,
    "Wholesale Price": 10000,
  },
];
